import ArticleLayout from '@/components/feature/ArticleLayout';
import { articlesData } from '@/mocks/articles-data';
import JsonLd from '@/components/base/JsonLd';
import { buildArticleJsonLd } from '@/mocks/seo-data';
import type { ArticleSeoData } from '@/mocks/seo-data';

const SEO: ArticleSeoData = {
  title: 'Tutorial Itaobuy Spreadsheet: Come Usare la Piattaforma Passo Dopo Passo',
  description: 'Tutorial pratico e dettagliato su come utilizzare Itaobuy Spreadsheet: dalla navigazione tra le categorie alla ricerca avanzata, dai consigli per risparmiare tempo alle strategie per trovare i prodotti migliori.',
  slug: '/articolo-tutorial-itaobuy-spreadsheet',
  datePublished: '2026-07-14',
  dateModified: '2026-07-14',
  authorName: 'Redazione Itaobuy Italia',
  heroImage: 'https://readdy.ai/api/search-image?query=Hands%20typing%20on%20laptop%20keyboard%20with%20organized%20notebook%20and%20coffee%20on%20light%20wooden%20desk%2C%20warm%20morning%20sunlight%2C%20step%20by%20step%20guide%20concept%2C%20sand%20and%20terracotta%20tones%2C%20clean%20editorial%20aesthetic%2C%20inviting%20learning%20atmosphere%20with%20eucalyptus%20branch&width=1600&height=600&seq=article-hero-tutorial-v2&orientation=landscape&nocache=true',
  breadcrumbItems: [
    { name: 'Home', item: 'https://itaobuyspread.lat/' },
    { name: 'Itaobuy Spreadsheet', item: 'https://itaobuyspread.lat/' },
    { name: 'Tutorial', item: 'https://itaobuyspread.lat/articolo-tutorial-itaobuy-spreadsheet' },
  ],
  faqs: [
    { question: 'Come inizio a usare Itaobuy Spreadsheet?', answer: 'Basta visitare la piattaforma dal browser e iniziare a esplorare le categorie. Non è necessario registrarsi per la navigazione di base. Consulta la nostra homepage per una panoramica completa.' },
    { question: 'Posso usare Itaobuy Spreadsheet sul telefono?', answer: "Sì, la piattaforma è accessibile da dispositivi mobili tramite browser. Per un'esperienza ottimale con la visualizzazione a spreadsheet, ti consigliamo di utilizzare il dispositivo in orizzontale." },
    { question: 'Quanto tempo ci vuole per imparare a usare Itaobuy Spreadsheet?', answer: "L'interfaccia è molto intuitiva: la maggior parte degli utenti si sente a proprio agio dopo pochi minuti di esplorazione. Per padroneggiare tutte le funzionalità, ti consigliamo di dedicare una o due sessioni di pratica." },
    { question: 'Come trovo prodotti specifici su Itaobuy Spreadsheet?', answer: 'Naviga nella categoria pertinente oppure utilizza il menu di navigazione per sfogliare tutte le categorie disponibili. La struttura a spreadsheet ti permette di visualizzare molti prodotti contemporaneamente.' },
    { question: 'Ci sono costi nascosti?', answer: 'La navigazione di base su Itaobuy Spreadsheet non comporta costi. Verifica sempre i termini aggiornati sulla piattaforma ufficiale per eventuali funzionalità premium.' },
    { question: 'Ogni quanto vengono aggiunti nuovi prodotti?', answer: 'La piattaforma viene aggiornata regolarmente. Ti consigliamo di visitare periodicamente le categorie di tuo interesse per scoprire le ultime novità.' },
  ],
};

const jsonLd = buildArticleJsonLd(SEO);

export default function ArticleTutorial() {
  const relatedArticles = [
    { title: 'Guida Completa a Itaobuy Spreadsheet', link: '/articolo-itaobuy-spreadsheet-guida', isInternal: true },
    { title: 'Sicurezza e Privacy su Itaobuy Spreadsheet', link: '/articolo-sicurezza-itaobuy-spreadsheet', isInternal: true },
    { title: 'Itaobuy Spreadsheet vs Alternative: Confronto', link: '/articolo-confronto-itaobuy-spreadsheet', isInternal: true },
  ];

  return (
    <>
      {jsonLd.map((data, i) => (
        <JsonLd key={i} data={data} />
      ))}
      <ArticleLayout article={articlesData.tutorial} relatedArticles={relatedArticles} />
    </>
  );
}